module.exports = __webpack_public_path__ + "img/gb-yo-whatsapp.bf7cca0a.webp";